/* eslint-disable max-len */
export const CLEAR_NEW_INFO = 'app/Payments/Sources/CLEAR_NEW_INFO';

export const NACHA_VALIDATION_FAILURE = 'app/Payments/Sources/NACHA_VALIDATION_FAILURE';

export const RESET_BANNER_ERRORS = 'app/Payments/Sources/RESET_BANNER_ERRORS';

export const RESET_FORM_STATE = 'app/Payments/Sources/RESET_FORM_STATE';

export const RESET_STATE = 'app/Payments/Sources/RESET_STATE';

export const SET_ACTIVE_ACCOUNT_FORM = 'app/Payments/Sources/SET_ACTIVE_ACCOUNT_FORM';

export const SET_EXISTING_INFO = 'app/Payments/Sources/SET_EXISTING_INFO';

export const SET_INPUT = 'app/Payments/Sources/SET_INPUT';
export const SET_INPUT_ERROR = 'app/Payments/Sources/SET_INPUT_ERROR';

export const SET_IS_SOURCE_DRAWER_OPEN = 'app/Payments/Sources/SET_IS_SOURCE_DRAWER_OPEN';

export const SET_USE_EXISTING = 'app/Payments/Sources/SET_USE_EXISTING';

export const SET_VALIDATE_ROUTING_ERROR = 'app/Payments/Sources/SET_VALIDATE_ROUTING_ERROR';

export const UPDATE_FORM_ERRORS = 'app/Payments/Sources/UPDATE_FORM_ERRORS';

export const VALIDATE_ROUTING = 'app/Payments/Sources/VALIDATE_ROUTING';
export const VALIDATE_ROUTING_FAILURE = 'app/Payments/Sources/VALIDATE_ROUTING_FAILURE';
export const VALIDATE_ROUTING_SUCCESS = 'app/Payments/Sources/VALIDATE_ROUTING_SUCCESS';

export const VALIDATE_ROUTING_FLEX_DRAFT = 'app/Payments/Sources/VALIDATE_ROUTING_FLEX_DRAFT';

export const DEFAULT_ERROR_MESSAGE = 'Your request could not be processed at this time. Please try again later or call customer service.';
export const VALIDATE_ROUTING_ERROR_MESSAGE = 'There was in issue validating your routing number. If this issue persists, please contact customer service.';

export const NACHA_DICTIONARY = {
  Error_Invalid_Token: true,
  Service_Unavailable: true,
  Unknown: true,
  Valid: true,
  Wait_Time_Out: true,
  Warning_Closed: true,
  Warning_Information_Not_Available: true,
};

export const PAYMENT_SOURCES_FIRST_ACCOUNT = 'firstAccount';
export const PAYMENT_SOURCES_SECOND_ACCOUNT = 'secondAccount';
